
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/counsellor-all",
      function () {
        return require("private-next-pages/counsellor-all.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/counsellor-all"])
      });
    }
  